import { cn } from "src/common/utils";

const FireHydrantIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "bg-white rounded-sm p-0.5")}>
    <svg
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M216.251 76.8033C206.254 42.2445 242.198 24.3042 252 20.1496C232.97 19.5831 218.171 20.5273 204.91 24.6819C179.345 31.6692 162.625 48.8543 134.755 88.3228L149.746 137.989L182.614 103.997L195.298 146.865L109 236C209.523 236 244.695 189.166 235.085 150.075L216.251 76.8033Z"
        fill="#FB8D58"
      />
      <path
        d="M122.21 167.737L107.199 118.114L74.2869 152.076L61.5832 109.246L148 20C47.3418 20 12.1221 66.7928 21.7448 105.85L40.7974 179.246C50.8052 213.775 14.8152 231.699 5 235.851C24.0527 236.417 38.8746 235.473 52.1532 231.322C77.5606 224.341 94.3025 207.171 122.21 167.737Z"
        fill="#FF5300"
      />
    </svg>
  </div>
);

export default FireHydrantIcon;